import React, { useContext, useMemo } from 'react';

type LabelsFormFieldContextValue = {
  timesheetLabels: string;
  note: string;
};

const LabelsFormFieldContext = React.createContext<LabelsFormFieldContextValue | null>(
  null
);

export const useLabelsFormFieldContext = (): LabelsFormFieldContextValue => {
  const val = useContext(LabelsFormFieldContext);
  if (!val) {
    throw new Error(
      'useLabelsFormFieldContext must be called within a LabelsFormFieldContextProvider'
    );
  }

  return val;
};

type LabelsFormFieldContextProviderProps = LabelsFormFieldContextValue & {
  children: React.ReactNode;
};

export const LabelsFormFieldContextProvider: React.FC<LabelsFormFieldContextProviderProps> = ({
  timesheetLabels,
  note,
  children
}: LabelsFormFieldContextProviderProps) => {
  return (
    <LabelsFormFieldContext.Provider
      value={useMemo(
        () => ({
          timesheetLabels,
          note
        }),
        [timesheetLabels, note]
      )}
    >
      {children}
    </LabelsFormFieldContext.Provider>
  );
};
